__turbopack_context__.v({
  "userBar": "UserBar-module-scss-module__h7kHKa__userBar",
  "userBar__logout": "UserBar-module-scss-module__h7kHKa__userBar__logout",
  "userBar__username": "UserBar-module-scss-module__h7kHKa__userBar__username",
});
